import { useState } from "react";
import { useLocation, Link } from "react-router-dom";
import { LifeBuoy, Phone, Ticket, MessageSquare, Calendar, X } from "lucide-react";
import { cn } from "@/lib/utils";
import { SUPPORT_PHONE, SUPPORT_PHONE_TEL, BOOKING_URL } from "@/lib/supportContent";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import PublicTicketForm from "@/components/support/PublicTicketForm";

const HIDE_PATHS = ["/auth", "/checkout", "/checkout/return"];

const FloatingSupportButton = () => {
  const [open, setOpen] = useState(false);
  const [ticketOpen, setTicketOpen] = useState(false);
  const location = useLocation();

  if (HIDE_PATHS.some((p) => location.pathname.startsWith(p))) return null;

  return (
    <>
      <div className="fixed bottom-20 left-4 sm:bottom-6 sm:left-6 z-[9998]">
        {open && (
          <div className="absolute bottom-16 left-0 w-64 bg-[#0A1828] border border-primary/30 rounded-2xl shadow-2xl p-3 animate-in slide-in-from-bottom-2">
            <div className="flex items-center justify-between mb-2 px-2 pt-1">
              <span className="text-xs uppercase tracking-wider text-primary font-semibold">24/7 Support</span>
              <button onClick={() => setOpen(false)} aria-label="Close" className="text-white/70 hover:text-white"><X className="w-4 h-4" /></button>
            </div>
            <a href={SUPPORT_PHONE_TEL} className="flex items-center gap-3 px-3 py-2 rounded-lg text-white hover:bg-primary/10 transition">
              <Phone className="w-4 h-4 text-primary" />
              <div><div className="text-sm font-semibold">Call Now</div><div className="text-xs text-muted-foreground">{SUPPORT_PHONE}</div></div>
            </a>
            <button
              onClick={() => { setTicketOpen(true); setOpen(false); }}
              className="w-full flex items-center gap-3 px-3 py-2 rounded-lg text-white hover:bg-primary/10 transition text-left"
            >
              <Ticket className="w-4 h-4 text-primary" />
              <div><div className="text-sm font-semibold">Open Ticket</div><div className="text-xs text-muted-foreground">No login required</div></div>
            </button>
            <button
              onClick={() => { window.dispatchEvent(new CustomEvent("open-support-chat")); setOpen(false); }}
              className="w-full flex items-center gap-3 px-3 py-2 rounded-lg text-white hover:bg-primary/10 transition text-left"
            >
              <MessageSquare className="w-4 h-4 text-primary" />
              <div><div className="text-sm font-semibold">Live Chat</div><div className="text-xs text-muted-foreground">AI assistant — instant</div></div>
            </button>
            <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 px-3 py-2 rounded-lg text-white hover:bg-primary/10 transition">
              <Calendar className="w-4 h-4 text-primary" />
              <div><div className="text-sm font-semibold">Book Service</div><div className="text-xs text-muted-foreground">Schedule a technician</div></div>
            </a>
            <Link to="/support" onClick={() => setOpen(false)} className="block text-center text-xs text-primary hover:underline mt-2 py-2">
              Visit Support Center →
            </Link>
          </div>
        )}
        <button
          onClick={() => setOpen(!open)}
          aria-label="Support menu"
          className={cn(
            "w-14 h-14 rounded-full flex items-center justify-center shadow-2xl transition-all duration-300 hover:scale-110",
            "bg-gradient-to-br from-[#FFD700] to-[#FFA500] text-[#05070A]"
          )}
        >
          {open ? <X className="w-6 h-6" /> : <LifeBuoy className="w-6 h-6" />}
        </button>
      </div>

      <Dialog open={ticketOpen} onOpenChange={setTicketOpen}>
        <DialogContent className="max-w-2xl bg-[#0A1828] border-primary/30 text-white max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="text-2xl">Open a Support Ticket</DialogTitle>
          </DialogHeader>
          <PublicTicketForm onSubmitted={() => setTimeout(() => setTicketOpen(false), 4000)} />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default FloatingSupportButton;
